(() => {
  const labels = ['Details', 'Fit & Fabric', 'Shipping & Return'];
  const normalise = value => value.replace(/\s+/g, ' ').trim();

  function enhance(section) {
    const root = section.matches?.('[id^="MainProduct-"]') ? section : section.querySelector?.('[id^="MainProduct-"]');
    if (!root || root.querySelector('[data-morii-product-info-tabs]')) return;

    const candidates = Array.from(root.querySelectorAll('.product__accordion'));
    const cards = labels.map(label => candidates.find(card => normalise(card.querySelector('.accordion__title')?.textContent || '') === label));
    if (cards.some(card => !card) || new Set(cards).size !== 3) return;
    const parent = cards[0].parentElement;
    const siblings = Array.from(parent.children);
    const start = siblings.indexOf(cards[0]);
    if (start < 0 || cards.some((card, index) => card.parentElement !== parent || siblings[start + index] !== card)) return;

    const tabs = document.createElement('div');
    tabs.className = 'morii-product-info-tabs__nav';
    tabs.setAttribute('role', 'tablist');
    tabs.setAttribute('aria-label', 'Product information');

    const wrapper = document.createElement('div');
    wrapper.className = 'morii-product-info-tabs';
    const controls = cards.map((card, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'morii-product-info-tabs__tab';
      button.textContent = labels[index];
      button.id = `${root.id}-info-tab-${index + 1}`;
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-controls', `${root.id}-info-panel-${index + 1}`);
      tabs.append(button);
      card.id = `${root.id}-info-panel-${index + 1}`;
      card.setAttribute('role', 'tabpanel');
      card.setAttribute('aria-labelledby', button.id);
      return button;
    });

    const activate = (index, focus = false) => {
      controls.forEach((button, position) => {
        const active = position === index;
        button.setAttribute('aria-selected', String(active));
        button.tabIndex = active ? 0 : -1;
        cards[position].hidden = !active;
        const details = cards[position].querySelector(':scope > .accordion__details');
        if (details) details.open = active;
      });
      if (focus) controls[index].focus();
    };

    controls.forEach((button, index) => {
      button.addEventListener('click', () => activate(index));
      button.addEventListener('keydown', event => {
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % controls.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + controls.length) % controls.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = controls.length - 1;
        else return;
        event.preventDefault();
        activate(next, true);
      });
    });

    cards[0].before(wrapper);
    wrapper.append(tabs, ...cards);
    activate(cards.findIndex(card => card.querySelector('.accordion__details')?.open) >= 0
      ? cards.findIndex(card => card.querySelector('.accordion__details')?.open)
      : 0);
    wrapper.dataset.moriiProductInfoTabs = 'true';
    wrapper.addEventListener('shopify:block:select', event => {
      const index = cards.indexOf(event.target.closest('.product__accordion'));
      if (index >= 0) activate(index);
    });
  }

  const run = () => document.querySelectorAll('[id^="MainProduct-"]').forEach(enhance);
  if (document.readyState === 'loading') {
    document.addEventListener('readystatechange', () => {
      if (document.readyState !== 'loading') run();
    }, { once: true });
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else run();
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
